import React from "react";

import {Highlight, Text} from "@pg-design/text-module";
import {numberFormat, pluralize} from "@pg-mono/string-utils";

interface IProps {
    vendor: {
        stats: {
            offers_count_for_sale: number;
            properties_count_for_sale: number;
        };
    };
    className?: string;
}

const offerPluralize = pluralize(["inwestycji", "inwestycjach", "inwestycjach"]);
const propertyPluralize = pluralize(["nieruchomość", "nieruchomości", "nieruchomości"]);

export const VendorDetailSubHeader: React.FC<IProps> = ({vendor, className}) => {
    const propertiesCount = vendor.stats.properties_count_for_sale;
    const offersCount = vendor.stats.offers_count_for_sale;

    return Number.isFinite(offersCount) ? (
        <Text as="h2" variant="headline_3" className={className}>
            Posiadamy w sprzedaży{" "}
            <Highlight>
                {numberFormat(propertiesCount)} {propertyPluralize(propertiesCount)} w {numberFormat(offersCount)} {offerPluralize(offersCount)}
            </Highlight>
        </Text>
    ) : null;
};
import React from "react";

import {Highlight, Text} from "@pg-design/text-module";
import {numberFormat, pluralize} from "@pg-mono/string-utils";

interface IProps {
    vendor: {
        stats: {
            offers_count_for_sale: number;
            properties_count_for_sale: number;
        };
    };
    className?: string;
}

const offerPluralize = pluralize(["inwestycji", "inwestycjach", "inwestycjach"]);
const propertyPluralize = pluralize(["nieruchomość", "nieruchomości", "nieruchomości"]);

export const VendorDetailSubHeader: React.FC<IProps> = ({vendor, className}) => {
    const propertiesCount = vendor.stats.properties_count_for_sale;
    const offersCount = vendor.stats.offers_count_for_sale;

    return Number.isFinite(offersCount) ? (
        <Text as="h2" variant="headline_3" className={className}>
            Posiadamy w sprzedaży{" "}
            <Highlight>
                {numberFormat(propertiesCount)} {propertyPluralize(propertiesCount)} w {numberFormat(offersCount)} {offerPluralize(offersCount)}
            </Highlight>
        </Text>
    ) : null;
};
